import type { ReactNode } from "react";

// 2px-stroke line icons (inline SVG, no emoji, no icon font).
function Icon({ children, size = 24, flipInRtl = false }: { children: ReactNode; size?: number; flipInRtl?: boolean }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={flipInRtl ? "rtl-flip" : undefined}
    >
      {children}
    </svg>
  );
}

export const FeedIcon = () => (
  <Icon>
    <path d="M4 6h16M4 12h16M4 18h10" />
  </Icon>
);
export const BookmarkIcon = ({ filled = false }: { filled?: boolean }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2" strokeLinejoin="round" aria-hidden="true">
    <path d="M6 3h12v18l-6-4.5L6 21z" />
  </svg>
);
export const ArchiveIcon = () => (
  <Icon>
    <path d="M3 5h18v4H3zM5 9v10h14V9M10 13h4" />
  </Icon>
);
export const SlidersIcon = () => (
  <Icon>
    <path d="M4 7h9M17 7h3M4 17h3M11 17h9" />
    <circle cx="15" cy="7" r="2" />
    <circle cx="9" cy="17" r="2" />
  </Icon>
);
export const ChevronEndIcon = () => (
  <Icon size={22} flipInRtl>
    <path d="M9 6l6 6-6 6" />
  </Icon>
);
export const CloseIcon = () => (
  <Icon size={22}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Icon>
);
export const ExternalIcon = () => (
  <Icon size={22}>
    <path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" />
  </Icon>
);
export const CopyIcon = () => (
  <Icon size={20}>
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15V6a2 2 0 0 1 2-2h9" />
  </Icon>
);
